import {gql} from '@apollo/client';
import {ReviewTaskDetail} from '../types/ReviewTaskType';
import {REVIEW_TASK_LIST_FIELDS} from './getReviewTaskList';

const REVIEW_TASK_LOG_FIELDS = `
    id
    reviewTaskId
    action
    fromStatus
    toStatus
    operatorId
    operatorName
    comment
    createdAt
`;

const COMPLAINT_FIELDS = `
    id
    complaintCategory
    complaintType
    source
    externalRefId
    externalRefCode
    driverId
    dspId
    orderId
    hubId
    warehouseId
    complaintReason {
        text
        lang
        translations {
            lang
            text
        }
    }
    evidenceFilesJson
    status
    isFinished
    appealDeadlineAt
    finishedAt
    createdAt
    updatedAt
`;

const COMPLAINT_APPEAL_FIELDS = `
    id
    complaintId
    reviewTaskId
    appealReason {
        text
        lang
        translations {
            lang
            text
        }
    }
    appealAttachmentS3UrlsJson
    reviewComment {
        tagKeys
        tagOptions {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
        text
        lang
        translations {
            lang
            text
        }
    }
    appealSubmittedAt
    appealSubmittedBy
    reviewResult
    reviewerId
    reviewedAt
`;

const ORDER_DETAIL_FIELDS = `
    overallStatus
    recipientName
    deliveryAddress
    deliveredAt
    driverName
    podImageS3UrlsJson
`;

export const GET_REVIEW_TASK_DETAIL = gql`
    query GetReviewTaskDetail($reviewTaskId: Long!) {
        getReviewTaskDetailById(reviewTaskId: $reviewTaskId) {
            reviewTask {
                ${REVIEW_TASK_LIST_FIELDS}
            }
            logs {
                ${REVIEW_TASK_LOG_FIELDS}
            }
            complaint {
                ${COMPLAINT_FIELDS}
            }
            complaintAppeal {
                ${COMPLAINT_APPEAL_FIELDS}
            }
            orderDetail {
                ${ORDER_DETAIL_FIELDS}
            }
        }
    }
`;

export interface GetReviewTaskDetailResponse {
    getReviewTaskDetailById?: ReviewTaskDetail;
}

export interface GetReviewTaskDetailVariables {
    reviewTaskId: number;
}
